import { recordPath, recordRoute } from '@/shared/registry'

/** Where the site pages live. */
export const sitesPath = '/site-management/sites'
export const createSitePath = `${sitesPath}/new`
export const siteRoute = recordRoute('site-management', 'sites')
export const editSiteRoute = `${siteRoute}/edit`

/** A site's details page. */
export function sitePath(id: string): string {
  return recordPath('site-management', 'sites', id)
}

/** The API's site endpoints. */
export const sitesApi = '/site-management/v1/sites'

export function siteApi(id: string): string {
  return `${sitesApi}/${encodeURIComponent(id)}`
}

/** A site's organizations, which its owner and default organization are picked from. */
export function siteOrganizationsApi(id: string): string {
  return `${siteApi(id)}/organizations`
}

/** One of a site's base URLs. */
export function siteBaseUrlApi(siteId: string, baseUrlId: string): string {
  return `${siteApi(siteId)}/base-urls/${encodeURIComponent(baseUrlId)}`
}

/** A site's branding. */
export function siteBrandingApi(id: string): string {
  return `${siteApi(id)}/branding`
}

/** A site's logo or favicon: PUT an upload's id to set it, after `/upload-link` issued the upload. */
export function siteImageApi(id: string, image: 'logo' | 'favicon'): string {
  return `${siteApi(id)}/${image}`
}

/** What each site action needs. */
export const readSitesPermission = 'site-management.sites.read'
export const writeSitesPermission = 'site-management.sites.write'
export const deleteSitesPermission = 'site-management.sites.delete'
export const writeSiteBaseUrlsPermission = 'site-management.sites.base-urls.write'
export const writeSiteBrandingPermission = 'site-management.sites.branding.write'
export const writeSiteSignInOptionsPermission = 'site-management.sites.sign-in-options.write'

/** Creating a site needs `writeSitesPermission` at this scope: its owner is a new organization nobody manages yet. */
export const createSiteScope = 'allOrganizations'
